var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52475 13.4499C6.92878 13.4499 8.87763 11.501 8.87763 9.09702C8.87763 6.69299 6.92878 4.74414 4.52475 4.74414C2.12072 4.74414 0.171875 6.69299 0.171875 9.09702C0.171875 11.501 2.12072 13.4499 4.52475 13.4499Z",
    fill: "url(#paint0_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51563 12.7305C6.52198 12.7305 8.14844 11.104 8.14844 9.09766C8.14844 7.09131 6.52198 5.46484 4.51563 5.46484C2.50928 5.46484 0.882812 7.09131 0.882812 9.09766C0.882812 11.104 2.50928 12.7305 4.51563 12.7305Z",
    fill: "url(#paint1_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.466 5.20312C6.75959 5.78904 6.92505 6.45031 6.92505 7.15029C6.92505 9.55431 4.97618 11.5032 2.57217 11.5032C1.87218 11.5032 1.21091 11.3377 0.625 11.0441C1.33967 12.4705 2.8148 13.4498 4.51883 13.4498C6.92285 13.4498 8.87171 11.501 8.87171 9.09696C8.87171 7.39293 7.89239 5.91779 6.466 5.20312V5.20312Z",
    fill: "url(#paint2_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12297 11.5351L6.46875 10.9893L7.62383 12.1443C7.80773 11.9569 7.97526 11.7533 8.12297 11.5351V11.5351Z",
    fill: "url(#paint3_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0411 9.5273C6.29334 8.89439 7.01089 8.58574 7.6438 8.83798L11.1624 10.2401C11.7953 10.4924 12.104 11.2099 11.8517 11.8428C11.5995 12.4758 10.8819 12.7844 10.249 12.5322L6.73042 11.13C6.09751 10.8778 5.78887 10.1603 6.0411 9.5273V9.5273Z",
    fill: "url(#paint4_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8034 22.2463C22.3417 22.2463 26.0208 18.5673 26.0208 14.0289C26.0208 9.49058 22.3417 5.81152 17.8034 5.81152C13.265 5.81152 9.58594 9.49058 9.58594 14.0289C9.58594 18.5673 13.265 22.2463 17.8034 22.2463Z",
    fill: "url(#paint5_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8035 20.8872C21.5911 20.8872 24.6616 17.8167 24.6616 14.0291C24.6616 10.2414 21.5911 7.1709 17.8035 7.1709C14.0158 7.1709 10.9453 10.2414 10.9453 14.0291C10.9453 17.8167 14.0158 20.8872 17.8035 20.8872Z",
    fill: "url(#paint6_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4798 6.67871C22.0341 7.78485 22.3465 9.03316 22.3465 10.3546C22.3465 14.893 18.6674 18.5721 14.129 18.5721C12.8076 18.5721 11.5593 18.2596 10.4531 17.7054C11.8023 20.3982 14.587 22.2469 17.8039 22.2469C22.3423 22.2469 26.0213 18.5679 26.0213 14.0296C26.0213 10.8126 24.1725 8.02792 21.4798 6.67871V6.67871Z",
    fill: "url(#paint7_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.019 14.2757C26.0214 14.1939 26.023 14.1118 26.023 14.0294C26.023 11.7769 25.1164 9.73631 23.6485 8.25195L21.7891 10.0458L26.019 14.2757Z",
    fill: "url(#paint8_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7734 19.3711L21.337 21.45C21.6733 21.2896 21.9969 21.1067 22.306 20.9038L20.7734 19.3711Z",
    fill: "url(#paint9_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4044 18.953C20.0504 18.7364 20.7497 19.0845 20.9662 19.7306L22.1701 23.3219C22.3866 23.9679 22.0385 24.6672 21.3925 24.8837C20.7465 25.1002 20.0472 24.7521 19.8307 24.1061L18.6268 20.5148C18.4103 19.8687 18.7584 19.1695 19.4044 18.953V18.953Z",
    fill: "url(#paint10_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7832 10.046C21.3014 9.56425 21.3014 8.78314 21.7832 8.30132L25.6802 4.40429C26.162 3.92253 26.9431 3.92253 27.4249 4.40429C27.9067 4.88604 27.9067 5.66716 27.4249 6.14897L23.5279 10.046C23.0461 10.5278 22.265 10.5278 21.7832 10.046V10.046Z",
    fill: "url(#paint11_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4779 8.70576C29.8819 8.70576 31.8308 6.75691 31.8308 4.35288C31.8308 1.94885 29.8819 0 27.4779 0C25.0739 0 23.125 1.94885 23.125 4.35288C23.125 6.75691 25.0739 8.70576 27.4779 8.70576Z",
    fill: "url(#paint12_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4844 7.98548C29.4908 7.98548 31.1173 6.35899 31.1173 4.35261C31.1173 2.34622 29.4908 0.719727 27.4844 0.719727C25.4781 0.719727 23.8516 2.34622 23.8516 4.35261C23.8516 6.35899 25.4781 7.98548 27.4844 7.98548Z",
    fill: "url(#paint13_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4269 0.458984C29.7205 1.0449 29.886 1.70617 29.886 2.40615C29.886 4.81016 27.9371 6.75903 25.5331 6.75903C24.8331 6.75903 24.1719 6.59357 23.5859 6.29998C24.3006 7.72637 25.7757 8.70569 27.4798 8.70569C29.8838 8.70569 31.8326 6.75683 31.8326 4.35282C31.8326 2.64879 30.8533 1.17371 29.4269 0.458984V0.458984Z",
    fill: "url(#paint14_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5872 31.9987C24.9913 31.9987 26.9401 30.0499 26.9401 27.6459C26.9401 25.2418 24.9913 23.293 22.5872 23.293C20.1832 23.293 18.2344 25.2418 18.2344 27.6459C18.2344 30.0499 20.1832 31.9987 22.5872 31.9987Z",
    fill: "url(#paint15_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5859 31.2793C24.5923 31.2793 26.2188 29.6528 26.2188 27.6465C26.2188 25.6401 24.5923 24.0137 22.5859 24.0137C20.5796 24.0137 18.9531 25.6401 18.9531 27.6465C18.9531 29.6528 20.5796 31.2793 22.5859 31.2793Z",
    fill: "url(#paint16_linear_152_663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5453 24.4453C25.6647 25.0897 25.6401 25.7709 25.4458 26.4434C24.7785 28.753 22.3653 30.0843 20.0557 29.417C19.3832 29.2227 18.7939 28.8801 18.3125 28.4355C18.6032 30.0042 19.7485 31.3544 21.3856 31.8275C23.6952 32.4948 26.1083 31.1634 26.7756 28.8539C27.2486 27.2168 26.7172 25.5279 25.5453 24.4453V24.4453Z",
    fill: "url(#paint17_linear_152_663)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_663",
    x1: 2.89608,
    y1: 7.46834,
    x2: 8.53379,
    y2: 13.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_663",
    x1: 5.03786,
    y1: 9.83805,
    x2: 2.35211,
    y2: 6.03043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_663",
    x1: 4.66999,
    y1: 10.7652,
    x2: 10.6532,
    y2: -0.362804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_663",
    x1: 8.1709,
    y1: 12.7377,
    x2: 7.41137,
    y2: 11.4569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_663",
    x1: 8.94055,
    y1: 10.6985,
    x2: 8.44907,
    y2: 11.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_663",
    x1: 14.7288,
    y1: 10.9544,
    x2: 25.3717,
    y2: 21.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_663",
    x1: 18.7894,
    y1: 15.4268,
    x2: 13.7192,
    y2: 8.23876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_663",
    x1: 18.0893,
    y1: 17.1789,
    x2: 29.3845,
    y2: -3.82871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_663",
    x1: 26.7857,
    y1: 13.2158,
    x2: 21.8373,
    y2: 8.26744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_663",
    x1: 22.908,
    y1: 21.9879,
    x2: 20.7038,
    y2: 20.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_663",
    x1: 21.604,
    y1: 21.5084,
    x2: 19.265,
    y2: 22.2931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_663",
    x1: 23.7198,
    y1: 6.34565,
    x2: 25.4642,
    y2: 8.09006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_663",
    x1: 25.8493,
    y1: 2.7242,
    x2: 31.4869,
    y2: 8.36193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_663",
    x1: 28.0067,
    y1: 5.093,
    x2: 25.321,
    y2: 1.28538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_663",
    x1: 27.631,
    y1: 6.02102,
    x2: 33.6142,
    y2: -5.10694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_152_663",
    x1: 21.4873,
    y1: 25.6656,
    x2: 25.3378,
    y2: 32.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_152_663",
    x1: 22.8944,
    y1: 28.5409,
    x2: 21.3719,
    y2: 24.1351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_152_663",
    x1: 22.2877,
    y1: 29.3285,
    x2: 31.1312,
    y2: 20.2979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT3);
export default __webpack_public_path__ + "static/media/t3.3baa7c915f1236cb51b2836d895939ca.svg";
export { ForwardRef as ReactComponent };